// extracted by mini-css-extract-plugin
export default {"image":"MediaThumb_image__eQizk"};